import styled from 'styled-components';
import {FolderProps} from './types';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';
import {Theme} from '../../../../stores/AppStore';

export const Wrapper = styled.button<
  Pick<FolderProps, 'isActive'>
>`
  vertical-align: middle;
  
  box-sizing: border-box;
  padding: 8px 10px;
  margin-right: 6px;
  margin-bottom: 6px;
  
  display: inline-grid;
  grid-auto-flow: column;
  align-items: center;
  column-gap: 10px;
  
  ${transition()};
  border-radius: 5px;
  border: 1px solid ${({theme}) => `
    ${theme.variables.borderColor};
  `};
  background-color: ${({theme, isActive}) => isActive ? theme.name === Theme.Dark ? `
    ${transparentize(.95, theme.colors.white)};
  ` : transparentize(.95, theme.variables.color) : undefined};
  
  &:hover {
    background-color: ${({theme, isActive}) => !isActive && `
      ${transparentize(.98, theme.colors.white)};
    `};
  }

  &:active {
    background-color: ${({theme, isActive}) => !isActive && `
      ${transparentize(.95, theme.colors.white)};
    `};
  }
`;

export const IconWrapper = styled.div<
  Pick<FolderProps, 'isActive'>
>`
  display: grid;
  align-items: center;
  justify-content: center;
  
  height: 18px;
  width: 18px;
  
  color: ${({theme, isActive}) => `
    ${isActive ? theme.name === Theme.Dark ? `
      ${theme.colors.white};
    ` : theme.colors.primary : theme.name === Theme.Dark ? `
      ${transparentize(.8, theme.colors.white)};
    ` : transparentize(.8, theme.variables.color)};
  `};
`;

export const Name = styled.span`
  font-size: 14px;
  font-weight: 500;
`;
